import { Routes } from '@angular/router';
import {inject} from '@angular/core';
import {LoginService} from './services/login.service';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/login/login.component').then( m => m.LoginComponent),
  },

  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then( m => m.LoginComponent),
  },

  {
    path: 'manage',
    canActivateChild: [() => inject(LoginService).isLoggedIn()], // Apply the guard to the parent route
    children: [
      {
        path: 'forms',
        loadComponent: () => import('./components/forms/forms.component').then( m => m.FormsComponent),
      },
      {
        path: 'preview/:id',
        loadComponent: () => import('./components/previewer/previewer.component').then( m => m.PreviewerComponent),
      },
      {
        path: 'csv/:id',
        loadComponent: () => import('./components/csv-exporting/csv-exporting.component').then( m => m.CsvExportingComponent),
      },
      {
        path: 'help',
        loadComponent: () => import('./components/help/help.component').then( m => m.HelpComponent),
      },
      {
        path: 'library',
        loadComponent: () => import('./components/library-checker/library-checker.component').then( m => m.LibraryCheckerComponent),
      },
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./components/page-not-found/page-not-found.component').then( m => m.PageNotFoundComponent),
  },
];
